// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"85f2fd15","455":"368bb399","457":"4272efc6","551":"2e295c25","977":"de35185b"}[chunkId] + ".chunk.js";
};